/** The Spanish smartScroll.md.js. Keep the two saying the same thing. */
const smartScroll = `
# Scroll inteligente

El scroll automático normal avanza a **una sola velocidad**, que solo puede acertar con el promedio
de una canción. El scroll inteligente le da a cada parte su propia velocidad: calcula cuánto dura
cada parte, mide qué tan alta es en la pantalla y hace que coincidan.

Lee el BPM y el compás de la canción, y luego la duración de cada parte: sus repeticiones, un
cifrado, las barras de compás de un instrumental o una estimación según la letra. El control de la
fila de herramientas pasa a ser un **porcentaje de ritmo**: 100% es el tempo escrito, y al cambiarlo
se estira toda la canción a la vez, no una parte sola.

## Para sacarle el máximo provecho

- **Pon el BPM y el compás de la canción.** Todo lo demás se calcula a partir de ellos, así que es
  lo único sin lo que el scroll inteligente no puede funcionar.
- **Pon las repeticiones** en cada parte que tocas más de una vez; si no, se cuenta como una sola
  vuelta y pasa demasiado rápido.
- **Dale un cifrado a la parte.** Un cifrado indica su propia duración exacta, en vez de contar la
  parte acorde por acorde o estimarla por sus líneas, así que es lo mejor que puede tener una parte.
  El botón **Cifrado** de la barra de la letra te lo arma: escrito en la letra de un instrumental
  como barras de compás, "| Dm | Em C | B |", y junto a la letra en una parte cantada. Una parte
  con cifrado suena con la duración que le da su cifrado, y el ritmo no la cambia.
- **Mide una parte que nunca termina de encajar** con el **Temporizador de repeticiones**, al lado en
  la misma barra. Una parte medida se usa tal como se midió, y el ritmo no la cambia.
`;

export default smartScroll;
